import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../core/layout/Card';
import Separator from '../../../core/layout/Separator';
import FormButtons from '../../../core/form/FormButtons';
import UpgradeContractProductsListContainer from './UpgradeContractProductsListContainer';
import Button from '../../../core/form/Button';

const UpgradeContractForm = (props) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
      }}
    >
      <Card loading={props.loading} title="Upgrade info">
        <p>The upgrade will begin in the next cycle.</p>
      </Card>
      <Separator />
      <Card
        title="Upgrade Products"
        actions={
          <Button
            label="Add Product"
            onClick={props.onAddProduct}
            disabled={props.submitting || props.loading || props.disabled}
          />
        }
      >
        <UpgradeContractProductsListContainer />
      </Card>
      <Separator />
      <FormButtons
        confirmLabel="Upgrade Contract"
        isDisabled={props.submitting || props.loading || props.disabled}
        isSubmitting={props.submitting}
        onReset={props.onReset}
      />
    </form>
  );
};

UpgradeContractForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onAddProduct: PropTypes.func.isRequired,
  values: PropTypes.object,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  loading: PropTypes.bool,
  contractType: PropTypes.string,
};
UpgradeContractForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
};

export default UpgradeContractForm;
